import Repository from "@/services/repository";

export default {
  createTagsRemoval(studyId, keywordsTextAndLocationIds, tags) {
    return Repository.post(`/a/${studyId}/keywords/remove_tags.json`, {
      keywordsTextAndLocationIds,
      tags,
    }).then((response) => response.data);
  },
};
